/* tslint:disable */
/* eslint-disable */
/**
 * Document Simulation API
 * API for managing document simulations and contractualization strategies
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileTypeEnum } from './FileTypeEnum';
import {
    FileTypeEnumFromJSON,
    FileTypeEnumFromJSONTyped,
    FileTypeEnumToJSON,
    FileTypeEnumToJSONTyped,
} from './FileTypeEnum';

/**
 * 
 * @export
 * @interface ProductDocumentDto
 */
export interface ProductDocumentDto {
    /**
     * 
     * @type {string}
     * @memberof ProductDocumentDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDocumentDto
     */
    label: string;
    /**
     * 
     * @type {Date}
     * @memberof ProductDocumentDto
     */
    creationDate: Date;
    /**
     * 
     * @type {string}
     * @memberof ProductDocumentDto
     */
    storedFileId: string;
    /**
     * 
     * @type {FileTypeEnum}
     * @memberof ProductDocumentDto
     */
    fileType: FileTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ProductDocumentDto
     */
    version: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDocumentDto
     */
    isGroup: boolean;
}



/**
 * Check if a given object implements the ProductDocumentDto interface.
 */
export function instanceOfProductDocumentDto(value: object): value is ProductDocumentDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('creationDate' in value) || value['creationDate'] === undefined) return false;
    if (!('storedFileId' in value) || value['storedFileId'] === undefined) return false;
    if (!('fileType' in value) || value['fileType'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('isGroup' in value) || value['isGroup'] === undefined) return false;
    return true;
}

export function ProductDocumentDtoFromJSON(json: any): ProductDocumentDto {
    return ProductDocumentDtoFromJSONTyped(json, false);
}

export function ProductDocumentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductDocumentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'creationDate': (new Date(json['creationDate'])),
        'storedFileId': json['storedFileId'],
        'fileType': FileTypeEnumFromJSON(json['fileType']),
        'version': json['version'],
        'isGroup': json['isGroup'],
    };
}

export function ProductDocumentDtoToJSON(json: any): ProductDocumentDto {
    return ProductDocumentDtoToJSONTyped(json, false);
}

export function ProductDocumentDtoToJSONTyped(value?: ProductDocumentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
        'creationDate': ((value['creationDate']).toISOString().substring(0,10)),
        'storedFileId': value['storedFileId'],
        'fileType': FileTypeEnumToJSON(value['fileType']),
        'version': value['version'],
        'isGroup': value['isGroup'],
    };
}

